// @ts-strict-ignore
import { Component, ElementRef, OnInit, Signal, viewChild, viewChildren } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { NotificationVO } from '@shared/vo/notification.vo';
import { SystemNotificationManager } from '@project/components/article/manager/system-notification.manager';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  imports: [TranslateModule, SvgIconComponent]
})
export class NewsComponent implements OnInit {

  private carouselCards: Signal<readonly ElementRef[]> = viewChildren("carouselCard");
  private carouselCardsWrapper: Signal<ElementRef> = viewChild("carouselCardsWrapper");

  public selectedCard: number = 0;
  public newsNotifications: NotificationVO[] = [];

  constructor(
    private systemNotificationManager: SystemNotificationManager,
    wagoApiClient: WagoApiClient,
  ) {
    // news cards need to be repositioned when the window is resized
    fromEvent(window, 'resize')
      .pipe(debounceTime(250),  takeUntilDestroyed())
      .subscribe((event) => {
        this.focusNewsCard(this.selectedCard);
      });

    wagoApiClient.$initialRequestFailed
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        window.setTimeout(() => this.focusNewsCard(0), 0);
      })
  }

  ngOnInit(): void {
    this.updateNews();
  }

  public async updateNews(): Promise<void> {
    this.newsNotifications = await this.systemNotificationManager.getNotificationsForLocation("news");
    /* focusNewsCard needs to be pushed back in the event loop like this here,
    because it needs the change-detection and re-rendering to be completed. */
    window.setTimeout(() => this.focusNewsCard(0), 0);
  }

  public focusNewsCard(selectedIndex: number): void {
    const carouselCards = this.carouselCards();
    if(selectedIndex < 0) {
      selectedIndex = carouselCards.length -1;
    } else if (selectedIndex >= carouselCards.length) {
      selectedIndex = 0;
    }
    this.selectedCard = selectedIndex;

    const wrapperWidth = this.carouselCardsWrapper()?.nativeElement.getBoundingClientRect().width;

    carouselCards?.forEach((card, i) => {
      card.nativeElement.classList.remove("active");
      card.nativeElement.style.zIndex = 100 - Math.abs(selectedIndex - i);

      const offsetX = (i-selectedIndex) * 170;
      card.nativeElement.style.marginLeft = `${offsetX + wrapperWidth / 2}px`;
    });

    if (carouselCards?.length > 0)
      carouselCards[selectedIndex]?.nativeElement.classList.add("active");
  }

  public getNewsContent(notification: NotificationVO): string {
    return this.systemNotificationManager.getNotificationText(notification);
  }
}
